var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.549,
    viewBox: "0 0 18 18.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8206",
    "data-name": "Group 8206",
    transform: "translate(0 0.549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_620",
    "data-name": "Subtraction 620",
    d: "M9,18A9,9,0,0,1,2.636,2.636a8.711,8.711,0,0,1,1.156-.973A.942.942,0,0,1,4,1.637a.569.569,0,0,1,.458.209.828.828,0,0,1,.166.632A7.922,7.922,0,0,0,1.173,9,7.826,7.826,0,1,0,16.826,9,7.742,7.742,0,0,0,13.36,2.54a.86.86,0,0,1,.159-.694.569.569,0,0,1,.458-.209.987.987,0,0,1,.262.039,9.423,9.423,0,0,1,1.124.96A9,9,0,0,1,9,18ZM9,1.174H8.976V0H9V1.173Z",
    fill: "#EA5876"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    y1: 7.22,
    transform: "translate(8.804 7.671) rotate(180)",
    fill: "none",
    stroke: "#EA5876",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/iconSignOut.96870b935fdb86e1a4d18e09433b9157.svg";
export { ForwardRef as ReactComponent };